import styled from 'styled-components'

import { login } from '../../styles/z-index'
import { minmedia, maxmedia } from '../../styles/media-queries'
import { white, bordergray, inputgray, darkgray, red, almostblack} from '../../styles/colors'
import { Wrapper as CheckBoxWrapper } from '../../components/CheckBox/styles'
import { Wrap as InputWrapper } from '../../components/Input/styles'
import { StyledButton as LoginButton } from '../../components/Button/styles'

export const Container = styled.div`
  width: 100%;
  max-width: calc(100% - 4rem);
  box-sizing: border-box;
  border-radius: 0.25rem;
  z-index: ${login}; //appear above overlay
  position: relative;
  ${minmedia.medium`
    max-width: 300px;
  `} ${minmedia.large`
    max-width: 440px;
    background: ${white};
  `};
`

export const Feedback = styled.div`
  margin-bottom: 1rem;
  margin-top: -0.5rem;
  color: ${red};
  font-size: 14px;
`

export const Content = styled.p`
  display: block;
  text-align: left;
  font-size: 14px;
  color: ${white};
  padding: 2rem 0;
  padding-top: 0.5rem;
  ${minmedia.large`
    color: ${almostblack};
    margin: 0 2rem;
    border-bottom: 1px solid ${bordergray};
  `};
`

export const FormContainer = styled.form`
  ${CheckBoxWrapper} {
    margin-top: 1.5rem;
  }

  ${minmedia.large`
    padding: 2rem;
  `};
  ${maxmedia.large`
    color: ${white};

    ${CheckBoxWrapper} {
      label {
        border-color: ${white};
        background: transparent;
      }
      label::after {
        border-color: ${white};
      }
      p {
        color: ${white};
      }
    }
    ${InputWrapper} input {
      background: transparent;
      border: 0;
      border-bottom: 1px solid ${white};
      border-radius: 0;
      color: ${white};
      padding: 0.5rem 1rem;
      padding-left: 1.75rem;

      & + div {
        left: 0;
      }
      & + div svg {
        fill: ${white} !important;
      }

      &::-webkit-input-placeholder {
        color: ${white};
      }
      &::-moz-placeholder {
        color: ${white};
      }
      &:-ms-input-placeholder {
        color: ${white};
      }
      &:focus {
        border: none;
        border-bottom: 1px solid ${red};
        box-shadow: none;
      }
    }

    ${LoginButton} {
      right: 0;
      border: 0;
      width: 100%;
    }
  `};
`

export const Header = styled.h2`
  display: none;
  text-align: center;
  margin: 0;
  font-size: 24px;
  padding: 1.5rem;
  border-bottom: 1px solid ${bordergray};
  width: 100%;

  ${minmedia.large`
    display: block;
  `};
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;

  ${maxmedia.large`
    & > div {
      width: 100%;
      text-align: center;
      border: 0;
    }
  `};
`

export const StyledLink = styled.a`
  transition: all 0.5s;
  color: ${inputgray};
  font-size: 16px;
  text-decoration: none;

  ${maxmedia.medium`
    font-size: 14px;
  `} ${maxmedia.large`
    width: 100%;
    text-align: right;
    margin-top: 1rem;
    color: ${white};
  `} &:hover {
    color: ${darkgray};
  }
`



// WEBPACK FOOTER //
// ./src/containers/PasswordForm/styles.js